import React from "react";
import { Button, Tooltip } from "antd";
import { MdOutlineWeb } from "react-icons/md";
import { openCmsWindow } from "./openCmsHandshake";

const CmsAppButton = ({
  label,
  destination,
  icon = <MdOutlineWeb size={18} />,
  color = "#1890ff",
}) => (
  <div className="mx-1">
    <Tooltip title={`Open ${label}`} placement="bottom">
      <Button
        shape="round"
        onClick={() => openCmsWindow(destination)}
        className="flex items-center px-3"
        style={{ height: "35px", color }}
        icon={icon}
      >
        {label}
      </Button>
    </Tooltip>
  </div>
);

export default CmsAppButton;
